
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import cIf from 'classnames';
import tsRest from 'ts-rest-client';
import { WaitSpinners } from 'ts-common-react-controls';
import { lastIndexOf, split, reduce, toLower, map, find, indexOf, some, concat, startsWith } from 'lodash';
import { PageSection as PageSectionCTL } from '../src/components/atoms';
import { ConfirmOK } from './modal';
import TranslatorManager from 'ts-translate-js';

const tr = TranslatorManager.boundTR; 

const sniffr = require("sniffr").default;

export function redirect(url){
    if (startsWith(url, "http://") || startsWith(url, "https://"))
        window.top.location.href = url;
    else
        window.location.href = url;
}

// RCOMBRIDGE_getURLToClientSite peut etre null si on est pas dans un iframe!
export const RCOMBRIDGE_getURLToClientSite = function(callback) {
    if(window.RCOMBRIDGE_getClientSiteURL)
        window.RCOMBRIDGE_getClientSiteURL((obj) => callback(obj));
};

// RCOMBRIDGE_getUrl peut etre null si on est pas dans un iframe!
export const RCOMBRIDGE_getClientSiteURLParams = function(callback, notInLowerCase) {
    if(window.RCOMBRIDGE_getClientSiteURL)
        window.RCOMBRIDGE_getClientSiteURL((obj) => {
            callback(getQueryStringParams(obj.url, notInLowerCase));
        });
};

export const PageSection = PageSectionCTL;

// headbandClassName peut etre null s'il n'y en a pas!
export function retrieveIFramePosition(headbandClassName, callback) {
    const handlerTimer = function() {
        if(window.innerWidth > 0) {
            if(typeof window.getFramePosition !== "undefined")
                window.getFramePosition(headbandClassName,
                                 function(pos) {
                                     callback(pos);
                                     setTimeout(handlerTimer, 5000);
                                 }.bind(this));
        }
        else
            setTimeout(handlerTimer, 100);
    }.bind(this);

    setTimeout(handlerTimer, 100);
}


export class NumberSpinner extends Component {
    constructor(props) {
        super(props);

        this.handleMinusClick = this.handleMinusClick.bind(this);
        this.handlePlusClick = this.handlePlusClick.bind(this);
        this.handleTextBoxClick = this.handleTextBoxClick.bind(this);
    }

    handleMinusClick(e) {
        e.stopPropagation();
        e.preventDefault();
        if(this.props.value > this.props.min)
            this.props.onChange(this.props.value - this.props.qtyMultipleOf);
    }

    handlePlusClick(e) {
        e.stopPropagation();
        e.preventDefault();
        if(this.props.value < this.props.max)
            this.props.onChange(this.props.value + this.props.qtyMultipleOf);
    }

    handleTextBoxClick(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    render() {
        const minReached = this.props.value <= this.props.min;
        const maxReached = (this.props.value + this.props.qtyMultipleOf) > this.props.max; // On vérifie à l'avance si on va défoncer la quantité permise lors d'un multiple! 

        let qty = this.props.value;

        if(this.props.hideZero && qty == 0)
            qty = "";

        return (
            <div className={this.props.className}>
                <span className="input-group-btn"><button type="button" className="btn btn-default" onClick={this.handleMinusClick} disabled={minReached || this.props.disabled}><span className="fa fa-minus"></span></button></span>
                <input name="" type="text" readOnly className="form-control text-center" disabled={this.props.disabled} value={qty} onClick={this.handleTextBoxClick} onFocus={(e) => e.target.select()} />
                <span className="input-group-btn"><button type="button" className="btn btn-default" onClick={this.handlePlusClick} disabled={maxReached || this.props.disabled}><span className="fa fa-plus"></span></button></span>
            </div>
        );
    }
}

NumberSpinner.propTypes = {
    value: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    disabled: PropTypes.bool,
    hideZero: PropTypes.bool,
    qtyMultipleOf: PropTypes.number,
    // step: PropTypes.number,
    onChange: PropTypes.func,
    className: PropTypes.string
};

NumberSpinner.defaultProps = {
    value: 0,
    min: Number.MIN_VALUE,
    max: Number.MAX_VALUE,
    hideZero: false,
    disabled: false,
    qtyMultipleOf: 1,
    className: "col-xs-12 input-group number-spinner",
    onChange: Function
};

export const WaitSpinner = createClass({
    displayName: "WaitSpinner",

    PropTypes: {
        size: PropTypes.string
    },

    render() {
        return (
            <div className="wait-spinner">
                <ul>
                    <li>
                        <i className={cIf("fa fa-spinner fa-pulse fa-fw spinner",
                                          { "fa-lg": (this.props.size == "xs"),
                                            "fa-2x": (this.props.size == "sm" || this.props.size == null),
                                            "fa-3x": (this.props.size == "md"),
                                            "fa-4x": (this.props.size == "lg"),
                                            "fa-5x": (this.props.size == "xl")
                        })}></i>
                    </li>
                    {this.props.children != null
                    ? <li>{this.props.children}</li>
                    : null}
                </ul>
            </div>
        );
    }
});

export class PleaseWaitSpinner extends Component {
    render() {
        return (
            <WaitSpinners.WaitSpinner {...this.props}>
                <span className={cIf("title", (this.props.size != null? this.props.size : "") )} >{tr("Veuillez patentier...")}</span>
            </WaitSpinners.WaitSpinner>
        );
    }
}
PleaseWaitSpinner.propTypes = {
    size: PropTypes.string,
    integ: PropTypes.string
};

export const OverlayWaitSpinner = createClass({
    displayName: "OverlayWaitSpinner",

    render() {
        return (
            <div className="overlay"><WaitSpinner {...this.props}></WaitSpinner></div>
        );
    }
});

export const PlaceToGoEnum =  {
    CONTINUE_SHOPPING: "CONTINUE_SHOPPING",
    GO_TO_CHECKOUT: "GO_TO_CHECKOUT",
    GO_TO_CART: "GO_TO_CART"
};

export class AddToCartButtons extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let buttons = null;
        if(this.props.processing)
            buttons = (
                <div>
                    <div className="hidden-xs pull-right">
                        <PleaseWaitSpinner size="md" />
                    </div>

                    <div className="visible-xs-block text-center">
                        <PleaseWaitSpinner size="md" />
                    </div>
                </div>
            );
        else {

            const continueShoppingOnClick = function() { this.props.onAddToCart(PlaceToGoEnum.CONTINUE_SHOPPING); }.bind(this);

            const goToCheckout = function() { this.props.onAddToCart(PlaceToGoEnum.GO_TO_CHECKOUT); }.bind(this);

            buttons = (
                <div>
                    <div className="hidden-xs btn-toolbar pull-right">
                        <button type="button"
                                className="btn btn-default
                            text-uppercase"
                                disabled={this.props.disabled}
                                onClick={continueShoppingOnClick}>
                            {tr("ticketpriceselection.addtocartandcontinueshopping")}
                        </button>
                        <button type="button"
                                className="btn
                            btn-primary
                            text-uppercase"
                                disabled={this.props.disabled}
                                onClick={goToCheckout}>
                            {tr("ticketpriceselection.checkout")}
                        </button>
                    </div>

                    <div className="visible-xs-block">
                        <button type="button"
                                className="btn btn-default
                            text-uppercase
                            col-xs-12"
                                disabled={this.props.disabled}
                                onClick={continueShoppingOnClick}>
                            {tr("ticketpriceselection.addtocartandcontinueshopping")}
                        </button>
                        <button type="button"
                                className="btn
                            btn-primary
                            text-uppercase
                            col-xs-12
                            mobile-spacing"
                                disabled={this.props.disabled}
                                onClick={goToCheckout}>
                            {tr("ticketpriceselection.checkout")}
                        </button>
                    </div>
                </div>
            );
        }
        return buttons;
    }
}

AddToCartButtons.propTypes = {
    onAddToCart: PropTypes.func.isRequired,
    processing: PropTypes.bool,
    disabled: PropTypes.bool
};

AddToCartButtons.defaultProps = {
    processing: false,
    disabled: false
};

// Liste de boutons horizontale sélectionnable ************
const hbsButtonShape = PropTypes.shape({
    value: PropTypes.any,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    selected: PropTypes.bool
});

// Version qui donne full control over les boutons
export class HorizontalButtonSelector extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let content = null;
        let defaultButton = null;
        let ctls = null;
        if (this.props.maxItemsForButtons == 0 || this.props.buttons.length < this.props.maxItemsForButtons) {

            if(this.props.defaultButton != null) {
                defaultButton = (<div className="default-btn btn-group"><HorizontalButtonSelectorButton key={this.props.defaultButton.text} {...this.props.defaultButton}/></div>);

            }

            ctls = map(this.props.buttons, (b) => <HorizontalButtonSelectorButton key={b.text} {...b}  />);

            content = (
                <div className={"btn-toolbar " + this.props.className}>
                    {defaultButton}
                    {ctls}
                </div>
            );
        }
        else {
            if(this.props.defaultButton != null) 
                defaultButton = (<div className="default-btn"><HorizontalButtonSelectorButton key={this.props.defaultButton.text} {...this.props.defaultButton}/></div>);

            ctls = (
                <HorizontalButtonSelectorDropdown optionalSelectionText={this.props.optionalSelectionText}
                                                    items={this.props.buttons}
                                                    value={this.props.value}
                />
            );

            content = (
                <ul className={"horizontalBar list-inline " + this.props.className} style={{display: "inline-table"}}>
                    <li>
                        {defaultButton}
                    </li>
                    <li>
                        {ctls}
                    </li>
                </ul>
            );

        }
        return content;
    }
}

HorizontalButtonSelector.propTypes = {
    defaultButton: hbsButtonShape,
    optionalSelectionText: PropTypes.string,
    maxItemsForButtons: PropTypes.number,
    buttons: PropTypes.arrayOf(hbsButtonShape),
    value: PropTypes.any, // The selected value
    className: PropTypes.string
};

HorizontalButtonSelector.defaultProps = {
    className: "", maxItemsForButtons: 0, defaultButton: null, value: 0
};

// Version auto qui fonction un peu comme un dropdown
export const HorizontalButtonSelectorArray = createClass({
    displayName: "HorizontalButtonSelectorArray",

    PropTypes: {
        defaultItem: PropTypes.object,
        items: PropTypes.arrayOf(PropTypes.object),
        valueField: PropTypes.string.isRequired,
        textField: PropTypes.string.isRequired,
        selectedValue: PropTypes.any, // The selected value
        optionalSelectionText: PropTypes.string,
        maxItemsForButtons: PropTypes.number,
        onClick: PropTypes.func, // f(clickedValue)
        className: PropTypes.string
    },

    getDefaultProps: function () {
        return { 
            items: [], 
            selectedValue: 0,
            defaultItem: null,
            valueField: "",
            textField: "",
            optionalSelectionText: "",
            maxItemsForButtons: 0,
            onClick: null
        };
    },

    handleButtonClick(value) {
        if(this.props.onClick != null)
            this.props.onClick(value);
    },

    render() {

        let defaultButton = null;
        if(this.props.defaultItem !== null)
            defaultButton = {
                value: this.props.defaultItem[this.props.valueField],
                text: this.props.defaultItem[this.props.textField],
                onClick: function() { this.handleButtonClick(this.props.defaultItem[this.props.valueField]); }.bind(this),
                selected: this.props.defaultItem[this.props.valueField] === this.props.selectedValue,
            };

        const buttons = map(this.props.items, (i) => ({
            value: i[this.props.valueField],
            text: i[this.props.textField],
            onClick: function() { this.handleButtonClick(i[this.props.valueField]); }.bind(this),
            selected: i[this.props.valueField] === this.props.selectedValue,
        }));

        return (
            <HorizontalButtonSelector className={this.props.className}
                                      optionalSelectionText={this.props.optionalSelectionText}
                                      maxItemsForButtons={this.props.maxItemsForButtons}
                                      defaultButton={defaultButton}
                                      buttons={buttons}
                                      value={this.props.selectedValue}/>
        );
    }
});


export const HorizontalButtonSelectorButton = createClass({
    displayName: "HorizontalButtonSelectorButton",

    PropTypes: hbsButtonShape.isRequired,

    getDefaultProps: function () {
        return {
            selected: false
        };
    },

    render() {
        const checkIcon = this.props.selected ? <span className="glyphicon glyphicon-ok"></span> : null;
        return <button
                   type="button" key={this.props.value}
                   className={cIf([ "btn", { "active": this.props.selected, "btn-primary": this.props.selected, "btn-default": !this.props.selected } ])}
                   onClick={this.props.onClick}>{checkIcon} {this.props.text}</button>;
    }
});

export class HorizontalButtonSelectorDropdown extends Component {
    constructor(props) {
        super(props);

        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleOnChange(e) {
        const item = find(this.props.items, ['value', parseInt(e.target.value)]);
        if(item != null)
            item.onClick();
    }

    render() {
        const selected = some(this.props.items, ['selected', true]);

        const items = concat({ value:0, text: this.props.optionalSelectionText, onClick: null, selected: !selected }, this.props.items);

        const optionsList = map(items, (item) => (<option key={item.value} value={item.value}>{item.text}</option>));


        const checkIcon = selected ? <span className="input-group-addon glyphicon glyphicon-ok" style={{marginRight:"5px"}}></span>
                      : null;

        return (
            <div className="dropdown">
                <div className={cIf(["dropdown-checkIcon", {"active" : selected, "input-group": selected}])}>
                    {checkIcon}
                    <select className="form-control" value={this.props.value} onChange={this.handleOnChange}>
                        {optionsList}
                    </select>
                </div>
            </div>
        );
    }
}

HorizontalButtonSelectorDropdown.propTypes = {
    items: PropTypes.arrayOf(hbsButtonShape).isRequired,
    optionalSelectionText: PropTypes.string,
    value: PropTypes.any // The selected value
};

HorizontalButtonSelectorDropdown.defaultProps = {
    items: [], value: 0
};

export const ErrorOnActionMessage = createClass({
    displayName: "ErrorOnActionMessage",

    PropTypes: {
        message: PropTypes.string
    },

    getInitialState: function () {
        return { showMessage:true};
    },

    handleOnOK() {
        this.setState({showMessage:false});
        window.location.reload();
    },

    render() {
        return (
            <ConfirmOK showCloseButton={false} title={tr("erroronaction.title")} message={this.props.message} onOK={this.handleOnOK} />
        );
    }
});

export const MembershipCardStatusEnum =  {
    NewCard: 0,
    ExistingCard: 1
};



// *************************************************************
// System that prevent IFrame security problem on safari, IPhones and IPads
// -------------------------------------------------------------

export function isInFrame() {
    return window != window.top;
}

export function isInFrameDifferentDomain() {
    return window.top.location != document.location;
}

export const testIFrameCookieSecurityIssue = function() {
    // Safari doesn't allow cookie until the client visits the full web site.

    if(window.top.location != document.location) // Check if we are in a IFrame
        if(!document.cookie) // If cookies arn't supported
            return true; // IFrame issue!
    
    if(isInFrame() && isInFrameDifferentDomain()) { // Check if we are in a IFrame, with a different domain 
        if(!document.cookie) // If cookies arn't supported
            return true; // IFrame issue!
    }

    return false; // No issue
};

export const getQueryStringParams = (url, notInLowerCase) => {
    const parts = url.substring(lastIndexOf(url, "?") + 1); // obj = { _id: UUID, url: string }

    const paramsString = split(parts, "&");
    return reduce(paramsString, (result, param) => {
        const paramStr = split(param, "=");

        if(notInLowerCase)
            result[paramStr[0]] = paramStr[1];
        else
            result[toLower(paramStr[0])] = paramStr[1];
        return result;
    }, {});
};

export const CookieSecurityWarningPanel = createClass({
    displayName: "CookieSecurityWarningPanel",

    PropTypes: {
        cookiesverified: PropTypes.bool,
        tsSiteDomain: PropTypes.string,
        urlClientSite: PropTypes.string,
        siteInfo: PropTypes.shape({
            name: PropTypes.string,
            aboutUrl: PropTypes.string,
            phone: PropTypes.string,
            tollFreePhone: PropTypes.string
        })
    },

    getDefaultProps: function () {
        return { 
            tsSiteDomain: "https://www.reservatech.net",
            cookiesverified: false,
            siteInfo: null,
            urlClientSite: null
        };
    },

    getInitialState() {
        return {
            helpdoc: null
        };
    },

    componentDidMount: function() {

        this.loadCookiesHelpDocSetting();
    },

    componentDidUpdate: function () {
        this.loadCookiesHelpDocSetting();
    },

    componentWillUnmount () {
        if(this.helpDocProm) this.helpDocProm.abort();
    },

    handleAuthorizeOtherSite () {
        let urlClientSite = document.referrer; // Protection au cas ou nous aurions aucun urlClientSite provenant du site client
        if(this.props.urlClientSite != null) 
            urlClientSite = this.props.urlClientSite;
        window.top.location.href = this.props.tsSiteDomain + "/cookie-verification?redirectURL=" + encodeURIComponent(urlClientSite); // document.referrer is THE safe way to do it cross domain. Reading window.top.location.href fails on safari
    },

    loadCookiesHelpDocSetting() {
        if(this.props.cookiesverified && this.state.helpdoc == null)
            this.helpDocProm = tsRest.get("/settings/cookies/helpdoc", { noCache: true })
                                     .done((helpdoc) => this.getBestCookiesHelpLink(helpdoc));
    },

    getBestCookiesHelpLink(helpdoc) {

        let s = new sniffr();
        s.sniff(navigator.userAgent);


        let helpdocfinded = find(helpdoc, function(doc) {
            const havebrowser = (indexOf(doc.browser, s.browser.name) > -1);
            const haveos = (indexOf(doc.os, s.os.name) > -1);

            if(havebrowser && haveos)
                return doc;
        });

        if(helpdocfinded == null)
            helpdocfinded = find(helpdoc, function(doc) {
                const havebrowser = (doc.browser.length == 0);
                const haveos = (indexOf(doc.os, s.os.name) > -1);

                if(havebrowser && haveos)
                    return doc;
            });

        if(helpdocfinded == null)
            helpdocfinded = find(helpdoc, function(doc) {
                const havebrowser = (indexOf(doc.browser, s.browser.name) > -1);
                const haveos = (doc.os.length == 0);

                if(havebrowser && haveos)
                    return doc;
            });
        if(helpdocfinded != null) {
            let doc = helpdocfinded.doc.fr;
            if(tsapp.twoLetterLang == "en")
                doc = helpdocfinded.en;
            
            this.setState({ helpdoc: doc });
        }

    },

    render() {
        const moreInfoText = this.props.siteInfo ?
                           tr("Pour plus d’informations sur cette procédure, n’hésitez pas à communiquer avec la billetterie au {phone} ou, sans frais, au {tollfree}.", { phone: this.props.siteInfo.phone, tollfree: this.props.siteInfo.tollFreePhone })
                         : tr("Pour plus d’informations sur cette procédure, n’hésitez pas à communiquer avec la billetterie.");
        
        let infosuppCtl = <p>{moreInfoText}</p>;

        if(this.state.helpdoc != null)
            infosuppCtl = <p>{tr("Pour plus d’informations sur cette procédure, vous retrouverez l'information de blocage/activation des témoins (cookies) en cliquant")} <strong><a href={this.state.helpdoc} rel="noopener noreferrer" target="_blank">{tr("ICI")}</a></strong>!</p>;

        let content = null;
        if(!this.props.cookiesverified){
            const youMustText = this.props.siteInfo ?
                              (<p>{tr("L'achat de billet en ligne est propulsé par la billetterie")} <a href={this.props.tsSiteDomain}>Reservatech.net</a>. {tr("Afin de pouvoir continuer vos achats, vous devez autoriser la")} <a href={this.props.tsSiteDomain}>{tr("billetterie")}</a> {tr("à intéragir sur le site de")} <a href={this.props.siteInfo.aboutURL}>{this.props.siteInfo.name}</a>.</p>)
                            : (<p>{tr("L'achat de billet en ligne est propulsé par la billetterie")} <a href={this.props.tsSiteDomain}>Reservatech.net</a>. {tr("Afin de pouvoir continuer vos achats, vous devez autoriser la")} <a href={this.props.tsSiteDomain}>{tr("billetterie")}</a> {tr("à intéragir avec ce site Web.")}</p>);


            content = (
                <div className="row">
                    <div className="col-xs-12">

                        <h3>{tr("Avant de procéder")}</h3>
                        
                        {youMustText}
                        
                        {infosuppCtl}

                        <button className="btn btn-primary pull-right" type="button" onClick={this.handleAuthorizeOtherSite}>{tr("Autoriser la billetterie Reservatech.net pour l'achat de mes billets")}</button>
                    </div>
                </div>);
        } else {
            content = (
                <div className="row">
                    <div className="col-xs-12">

                        <h3>{tr("Vos témoins (cookies) sont désactivés")}</h3>


                        <p>{tr("Afin de pouvoir continuer vos achats, vous devez aller dans les options de votre navigateur pour procéder à l'activation de vos témoins (cookies).")}</p>

                        {infosuppCtl}
                        
                        <button className="btn btn-primary pull-right" type="button" onClick={this.handleAuthorizeOtherSite}>{tr("J'ai activé mes cookies, réessayer")}</button>
                    </div>
                </div>);
                    }
                
                return (
                    content
                );
    }


});
